export enum ZipCheckStatus {
  default = 'default',
  isDeliverable = 'isDeliverable',
  isNotDeliverable = 'isNotDeliverable',
}
